
import React, { memo, } from 'react';
import theme from './style';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Paper, Button } from '@material-ui/core';
import { withRouter } from "react-router-dom";
import translate from '../../misc/applyTranslation';
import {useConfig} from "../../context/configContext";
import ListAltIcon from '@material-ui/icons/ListAlt';
import PersonIcon from '@material-ui/icons/Person';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const CustomerListView = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const { userData } = props;
  const {
    name,
    name2,
  } = userData;

  const { match, history } = props;
  const lang = (match && match.params && match.params.lang) ? match.params.lang : 'se';
  const go = (path) => history.push('/' + lang + path);

  return (
    <React.Fragment>
      <Paper className={classes.container}>
        <div className='titleHome'>{translate('home', 'welcome')}, <br></br> <span>{name} {name2}</span></div>
        <div className='logo' />
      </Paper>

      <Paper className={classes.quickActions}>
        <div className={classes.quickActionsTitle}>{translate('home-mobile', 'quick_actions')}</div>
        <div className={classes.quickActionsGrid}>
          <Button className={classes.quickActionBtn} onClick={() => go('/stel-invoices')}>
            <span className={classes.quickActionLeft}>
              <ListAltIcon className={classes.quickActionIcon} />
              <span>{translate('', 'menu_user_view_invoices')}</span>
            </span>
            <ChevronRightIcon className={classes.quickActionArrow} />
          </Button>

          <Button className={classes.quickActionBtn} onClick={() => go('/my-info')}>
            <span className={classes.quickActionLeft}>
              <PersonIcon className={classes.quickActionIcon} />
              <span>{translate('', 'menu_user_my_info')}</span>
            </span>
            <ChevronRightIcon className={classes.quickActionArrow} />
          </Button>

          <Button className={classes.quickActionBtn} onClick={() => go('/contacts')}>
            <span className={classes.quickActionLeft}>
              <ContactSupportIcon className={classes.quickActionIcon} />
              <span>{translate('', 'menu_user_contacts')}</span>
            </span>
            <ChevronRightIcon className={classes.quickActionArrow} />
          </Button>
        </div>
      </Paper>
    </React.Fragment>
  )
}

const mapStateToProps = store => ({
  userData: store.login.userData,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(memo(CustomerListView)));
